import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.support.module.mentoring');
import { OnInit, OnChanges, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-portal-lpsysadmin-support-module-mentoring',
template: templateSource || '',
    styles: [``],
})
export class PortalLpsysadminSupportModuleMentoringComponent implements OnInit, OnChanges, OnDestroy {
    @Input() program_id: string = '';
    @Input() module_id: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public loaded: boolean = false;
    public module: any = null;
    public config: any = { mentors: [], matching: {} };
    public sessions: any[] = [];
    public applications: any[] = [];
    public mentorUsers: any[] = [];
    public selectedSession: any = null;
    public attendance: any[] = [];

    public tab: string = 'mentors'; // mentors | sessions | matching | attendance | coordinate | documents

    public newMentor: any = { name: '', email: '', expertise: '', phone: '', org: '' };

    public newSession: any = this._emptySession();
    public showSessionEditor: boolean = false;
    public editingSession: any = null;

    // 1:1 일정조율 / 채팅 / 멘티초대
    public assignments: any[] = [];
    public selectedAssignment: any = null;
    public proposals: any[] = [];
    public messages: any[] = [];
    public messageInput: string = '';
    public lastMessageId: string = '';
    public proposalForm: any = this._emptyProposal();
    public showProposalEditor: boolean = false;
    public showInviteResult: boolean = false;
    public inviteResult: any = null;
    public inviteLoading: any = {};
    public mentorInviteLoading: any = {};
    public selectedInviteAssignmentIds: any = {};
    public bulkInviteLoading: boolean = false;
    public showAssignmentRequestEditor: boolean = false;
    public assignmentRequestForm: any = this._emptyAssignmentRequest();
    public moduleAssignmentRequest: any = this._emptyAssignmentRequest();
    public moduleAssignmentRequestSaving: boolean = false;
    public assignmentForm: any = this._emptyMentorAssignmentForm();
    private chatPollTimer: any = null;

    // 멘토 제출서류
    public mentorDocMode: string = 'provide';
    public mentorDocSubmissions: any[] = [];
    public selectedMentorDocSubmission: any = null;
    public showMentorDocEditor: boolean = false;
    public editingMentorDoc: any = null;
    public mentorDocForm: any = this._emptyMentorDoc('provide');
    public newMentorDocField: any = { key: '', label: '', type: 'text', required: false, options: '' };
    public mentorDocFieldTypes: any[] = [
        { key: 'text', label: '짧은 답변' },
        { key: 'textarea', label: '긴 답변' },
        { key: 'date', label: '날짜' },
        { key: 'number', label: '숫자' },
        { key: 'select', label: '선택' },
        { key: 'checkbox', label: '동의 체크' },
        { key: 'file', label: '파일' },
    ];

    public proposalStatusMap: any = {
        proposed: { label: '제안중', cls: 'bg-blue-50 text-blue-700' },
        accepted: { label: '확정', cls: 'bg-emerald-50 text-emerald-700' },
        rejected: { label: '거절', cls: 'bg-red-50 text-red-700' },
        cancelled: { label: '취소', cls: 'bg-zinc-100 text-zinc-600' },
        rescheduled: { label: '재조정', cls: 'bg-amber-50 text-amber-700' },
    };

    public sessionStatusMap: any = {
        planned: { label: '예정', cls: 'bg-blue-50 text-blue-700' },
        ongoing: { label: '진행중', cls: 'bg-emerald-50 text-emerald-700' },
        done: { label: '완료', cls: 'bg-zinc-100 text-zinc-700' },
        cancelled: { label: '취소', cls: 'bg-red-50 text-red-700' },
    };
    public attStatusMap: any = {
        registered: { label: '등록', cls: 'bg-zinc-100 text-zinc-700' },
        attended: { label: '참석', cls: 'bg-emerald-100 text-emerald-800' },
        absent: { label: '결석', cls: 'bg-red-100 text-red-800' },
        excused: { label: '공결', cls: 'bg-amber-100 text-amber-800' },
    };

    public async ngOnInit() {
        await this.service.init();
        await this.reload();
    }

    public async ngOnChanges() {
        if (this.module_id) await this.reload();
    }

    private _emptySession() {
        return {
            module_id: '', program_id: '', round_no: 1, title: '',
            start_at: '', end_at: '', location: '', online_url: '',
            instructor: '', materials: '', status: 'planned'
        };
    }

    private async reload() {
        if (!this.module_id) return;
        this.loaded = false;
        await this.service.render();
        const r = await wiz.call('get_module', { module_id: this.module_id });
        if (r.code != 200) {
            this.service.alert.show({ title: '오류', message: r.data?.message || '모듈 로딩 실패', action: '확인' });
            return;
        }
        this.module = r.data.data;
        this.config = (this.module.config && typeof this.module.config === 'object') ? this.module.config : {};
        if (!Array.isArray(this.config.mentors)) this.config.mentors = [];
        if (!this.config.matching) this.config.matching = {};
        this.moduleAssignmentRequest = this._normalizeAssignmentRequest(this.config.assignment_request);
        this.config.mentor_documents = this._normalizeMentorDocuments(this.config.mentor_documents);
        await this.loadSessions();
        await this.loadApplications();
        await this.loadMentorUsers();
        await this.loadAssignments();
        await this.loadMentorDocSubmissions();
        this.loaded = true;
        await this.service.render();
    }

    private _emptyProposal() {
        return {
            title: '멘토링 일정 제안',
            duration_min: 60, location: '', online_url: '', note: '',
            slots: [{ datetime: '', label: '' }, { datetime: '', label: '' }, { datetime: '', label: '' }],
        };
    }

    private _emptyAssignmentRequest() {
        return { documents: '', note: '' };
    }

    private _emptyMentorAssignmentForm(): any {
        return {
            application_id: '',
            mentor_user_id: '',
            role: 'mentor',
            note: '',
            start_at: '',
            end_at: '',
            duration_min: 60,
            location: '',
            online_url: '',
            schedule_note: '',
        };
    }

    private _normalizeAssignmentRequest(req: any): any {
        return {
            documents: req?.documents || req?.request_documents || '',
            note: req?.note || req?.request_note || '',
            title: req?.title || req?.request_title || '',
        };
    }

    private _hasRequest(req: any): boolean {
        return !!((req?.documents || '').trim() || (req?.note || '').trim() || (req?.title || '').trim());
    }

    public async loadAssignments() {
        const r = await wiz.call('list_assignments', { program_id: this.program_id, module_id: this.module_id });
        if (r.code == 200) {
            this.assignments = r.data.rows || [];
            const validIds: any = {};
            for (const a of this.assignments) validIds[a.id] = true;
            for (const id of Object.keys(this.selectedInviteAssignmentIds || {})) {
                if (!validIds[id]) delete this.selectedInviteAssignmentIds[id];
            }
        }
        await this.service.render();
    }

    public async selectAssignment(a: any) {
        this.selectedAssignment = a;
        this.lastMessageId = '';
        this.messages = [];
        await this.loadProposals();
        await this.loadMessages(true);
        if (this.chatPollTimer) clearInterval(this.chatPollTimer);
        this.chatPollTimer = setInterval(() => this.pollMessages(), 2500);
        await this.service.render();
    }

    public async loadProposals() {
        if (!this.selectedAssignment) return;
        const r = await wiz.call('list_proposals', { assignment_id: this.selectedAssignment.id });
        if (r.code == 200) this.proposals = r.data.rows || [];
        await this.service.render();
    }

    public async loadMessages(initial: boolean = false) {
        if (!this.selectedAssignment) return;
        const r = await wiz.call('list_messages', { assignment_id: this.selectedAssignment.id });
        if (r.code == 200) {
            this.messages = r.data.rows || [];
            if (this.messages.length > 0) this.lastMessageId = this.messages[this.messages.length - 1].id;
        }
        await this.service.render();
        if (initial) setTimeout(() => this.scrollChatBottom(), 80);
    }

    public async pollMessages() {
        if (this.tab !== 'coordinate' || !this.selectedAssignment) return;
        const r = await wiz.call('list_messages', { assignment_id: this.selectedAssignment.id, since_id: this.lastMessageId });
        if (r.code == 200 && r.data.rows && r.data.rows.length > 0) {
            this.messages = [...this.messages, ...r.data.rows];
            this.lastMessageId = this.messages[this.messages.length - 1].id;
            await this.service.render();
            setTimeout(() => this.scrollChatBottom(), 50);
        }
    }

    public scrollChatBottom() {
        const el = document.getElementById('admin-chat-scroll');
        if (el) el.scrollTop = el.scrollHeight;
    }

    public async sendChat() {
        const msg = (this.messageInput || '').trim();
        if (!msg || !this.selectedAssignment) return;
        this.messageInput = '';
        const r = await wiz.call('send_message', {
            assignment_id: this.selectedAssignment.id,
            message: msg, sender_type: 'mentor',
        });
        if (r.code != 200) {
            this.service.alert.show({ title: '전송 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        await this.pollMessages();
    }

    public chatKeydown(ev: KeyboardEvent) {
        if (ev.key === 'Enter' && !ev.shiftKey) {
            ev.preventDefault();
            this.sendChat();
        }
    }

    public openProposalEditor() {
        this.proposalForm = this._emptyProposal();
        this.showProposalEditor = true;
        this.service.render();
    }

    public closeProposalEditor() {
        this.showProposalEditor = false;
        this.service.render();
    }

    public addProposalSlot() {
        this.proposalForm.slots.push({ datetime: '', label: '' });
    }

    public removeProposalSlot(i: number) {
        this.proposalForm.slots.splice(i, 1);
    }

    public async submitProposal() {
        if (!this.selectedAssignment) return;
        const slots = (this.proposalForm.slots || []).filter((s: any) => s.datetime);
        if (slots.length === 0) {
            this.service.alert.show({ title: '입력', message: '최소 1개의 후보 시간을 입력하세요.', action: '확인' });
            return;
        }
        const payload: any = {
            program_id: this.program_id,
            module_id: this.module_id,
            assignment_id: this.selectedAssignment.id,
            mentor_user_id: this.selectedAssignment.mentor_user_id,
            application_id: this.selectedAssignment.application_id,
            title: this.proposalForm.title,
            duration_min: Number(this.proposalForm.duration_min) || 60,
            location: this.proposalForm.location,
            online_url: this.proposalForm.online_url,
            note: this.proposalForm.note,
            slots: slots,
        };
        const r = await wiz.call('create_proposal', { data: JSON.stringify(payload) });
        if (r.code != 200) {
            this.service.alert.show({ title: '제안 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        this.showProposalEditor = false;
        await this.loadProposals();
    }

    public async deleteProposal(p: any) {
        if (!confirm('제안을 삭제하시겠습니까?')) return;
        const r = await wiz.call('delete_proposal', { proposal_id: p.id });
        if (r.code != 200) {
            this.service.alert.show({ title: '삭제 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        await this.loadProposals();
    }

    public async createMenteeInvite() {
        if (!this.selectedAssignment) return;
        if (!confirm('멘티에게 초대 메일을 발송하시겠습니까?\n(이메일 링크로 멘티가 로그인 없이 일정조율 / 채팅이 가능합니다.)')) return;
        const r = await this._sendMenteeInvite(this.selectedAssignment);
        if (r.code != 200) {
            this.service.alert.show({ title: '실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        this.inviteResult = r.data.data;
        this.showInviteResult = true;
        await this.service.render();
    }

    private async _sendMenteeInvite(a: any): Promise<any> {
        this.inviteLoading[a.id] = true;
        await this.service.render();
        const r = await wiz.call('create_mentee_invite', { assignment_id: a.id });
        this.inviteLoading[a.id] = false;
        return r;
    }

    public toggleInviteAssignment(a: any, checked: boolean) {
        if (!a?.id) return;
        this.selectedInviteAssignmentIds[a.id] = !!checked;
        this.service.render();
    }

    public isInviteAssignmentSelected(a: any): boolean {
        return !!(a?.id && this.selectedInviteAssignmentIds[a.id]);
    }

    public isSelectedAssignmentInviteLoading(): boolean {
        return !!(this.selectedAssignment?.id && this.inviteLoading[this.selectedAssignment.id]);
    }

    public isSelectedAssignmentMentorInviteLoading(): boolean {
        return !!(this.selectedAssignment?.id && this.mentorInviteLoading[this.selectedAssignment.id]);
    }

    public selectedInviteAssignmentCount(): number {
        return Object.keys(this.selectedInviteAssignmentIds || {}).filter((id: string) => !!this.selectedInviteAssignmentIds[id]).length;
    }

    public selectedInviteAssignments(): any[] {
        return (this.assignments || []).filter((a: any) => !!this.selectedInviteAssignmentIds[a.id]);
    }

    private async _sendMentorInvite(a: any): Promise<any> {
        this.mentorInviteLoading[a.id] = true;
        await this.service.render();
        const r = await wiz.call('send_mentor_assignment_invite', { assignment_id: a.id });
        this.mentorInviteLoading[a.id] = false;
        return r;
    }

    public async sendSelectedMentorInvites() {
        const targets = this.selectedInviteAssignments();
        if (targets.length === 0) return;
        if (!confirm(`선택한 ${targets.length}건의 멘토에게 배정 안내 메일을 발송하시겠습니까?`)) return;
        this.bulkInviteLoading = true;
        await this.service.render();
        let sent = 0;
        let failed = 0;
        for (const a of targets) {
            const r = await this._sendMentorInvite(a);
            if (r.code == 200) sent += 1;
            else failed += 1;
        }
        this.bulkInviteLoading = false;
        this.service.alert.show({ title: '발송 완료', message: `발송 ${sent}건 / 실패 ${failed}건`, action: '확인' });
        await this.service.render();
    }

    public async sendSelectedAssignmentMentorInvite() {
        if (!this.selectedAssignment) return;
        if (!confirm('선택한 멘토에게 배정 안내 메일을 발송하시겠습니까?')) return;
        const r = await this._sendMentorInvite(this.selectedAssignment);
        if (r.code != 200) {
            this.service.alert.show({ title: '실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        this.service.alert.show({ title: '발송 완료', message: '멘토 배정 안내 메일을 발송했습니다.', action: '확인' });
        await this.service.render();
    }

    public async sendSelectedMenteeInvites() {
        const targets = this.selectedInviteAssignments();
        if (targets.length === 0) return;
        if (!confirm(`선택한 ${targets.length}건의 멘토-기업 매칭에 초대 메일을 발송하시겠습니까?`)) return;
        this.bulkInviteLoading = true;
        await this.service.render();
        let sent = 0;
        let failed = 0;
        for (const a of targets) {
            const r = await this._sendMenteeInvite(a);
            if (r.code == 200) sent += 1;
            else failed += 1;
        }
        this.bulkInviteLoading = false;
        this.service.alert.show({ title: '발송 완료', message: `발송 ${sent}건 / 실패 ${failed}건`, action: '확인' });
        await this.service.render();
    }

    public assignmentRequest(a: any = this.selectedAssignment): any {
        const req = a?.assignment_request || a?.extra?.assignment_request || {};
        const normalized = this._normalizeAssignmentRequest(req);
        return this._hasRequest(normalized) ? normalized : { ...this.moduleAssignmentRequest };
    }

    public hasAssignmentRequest(a: any = this.selectedAssignment): boolean {
        const req = this.assignmentRequest(a);
        return !!((req.documents || '').trim() || (req.note || '').trim());
    }

    public assignmentRequestSummary(a: any = this.selectedAssignment): string {
        const req = this.assignmentRequest(a);
        const docs = String(req.documents || '').split('\n').map((v: string) => v.trim()).filter(Boolean);
        if (docs.length > 0) return `요청서류 ${docs.length}건`;
        if ((req.note || '').trim()) return '요청사항 있음';
        return '요청 없음';
    }

    public moduleAssignmentRequestSummary(): string {
        const docs = String(this.moduleAssignmentRequest?.documents || '').split('\n').map((v: string) => v.trim()).filter(Boolean);
        if (docs.length > 0) return `요청서류 ${docs.length}건`;
        if ((this.moduleAssignmentRequest?.note || '').trim()) return '요청사항 있음';
        return '요청 없음';
    }

    public async saveModuleAssignmentRequest() {
        if (this.moduleAssignmentRequestSaving) return;
        this.moduleAssignmentRequestSaving = true;
        await this.service.render();
        try {
            const r = await wiz.call('update_assignment_request', {
                module_id: this.module_id,
                request: JSON.stringify(this.moduleAssignmentRequest || {}),
            });
            if (r.code != 200) {
                this.service.alert.show({ title: '저장 실패', message: r.data?.message || '공통 요청자료 저장 중 오류가 발생했습니다.', action: '확인' });
                return;
            }
            const result = r.data?.result || {};
            this.moduleAssignmentRequest = this._normalizeAssignmentRequest(result.request || this.moduleAssignmentRequest);
            this.config.assignment_request = { ...this.moduleAssignmentRequest };
            await this.loadAssignments();
            const current = (this.assignments || []).find((a: any) => a.id === this.selectedAssignment?.id);
            if (current) this.selectedAssignment = current;
            this.service.alert.show({ title: '저장 완료', message: `현재 배정 ${result.updated || 0}건에 반영했습니다.`, action: '확인' });
        } finally {
            this.moduleAssignmentRequestSaving = false;
            await this.service.render();
        }
    }

    public requestDocumentLines(value: any): string[] {
        return String(value || '').split('\n').map((v: string) => v.trim()).filter((v: string) => !!v);
    }

    public openAssignmentRequestEditor() {
        if (!this.selectedAssignment) return;
        this.assignmentRequestForm = { ...this.assignmentRequest(this.selectedAssignment) };
        this.showAssignmentRequestEditor = true;
        this.service.render();
    }

    public closeAssignmentRequestEditor() {
        this.showAssignmentRequestEditor = false;
        this.assignmentRequestForm = this._emptyAssignmentRequest();
        this.service.render();
    }

    public async saveAssignmentRequest() {
        if (!this.selectedAssignment) return;
        const r = await wiz.call('assign_mentor', {
            program_id: this.selectedAssignment.program_id || this.program_id,
            module_id: this.selectedAssignment.module_id || this.module_id,
            mentor_user_id: this.selectedAssignment.mentor_user_id,
            application_id: this.selectedAssignment.application_id || '',
            role: this.selectedAssignment.role || 'primary',
            note: this.selectedAssignment.note || '',
            request: JSON.stringify(this.assignmentRequestForm || {}),
        });
        if (r.code != 200) {
            this.service.alert.show({ title: '저장 실패', message: r.data?.message || '요청사항 저장 중 오류가 발생했습니다.', action: '확인' });
            return;
        }
        this.closeAssignmentRequestEditor();
        await this.loadAssignments();
        const current = (this.assignments || []).find((a: any) => a.id === this.selectedAssignment?.id);
        if (current) this.selectedAssignment = current;
        await this.service.render();
    }

    public proposalStatusInfo(s: string) {
        return this.proposalStatusMap[s] || { label: s, cls: 'bg-zinc-100 text-zinc-600' };
    }

    public mentorName(uid: string): string {
        const m = (this.config.mentors || []).find((x: any) => x.id === uid || x.user_id === uid);
        return m ? m.name : uid;
    }

    public companyNameForApp(appId: string): string {
        const a = this.applications.find(x => x.id === appId);
        return a ? a.company_name : appId;
    }

    public ngOnDestroy() {
        if (this.chatPollTimer) clearInterval(this.chatPollTimer);
    }

    public async loadSessions() {
        const r = await wiz.call('list_sessions', { module_id: this.module_id });
        if (r.code == 200) this.sessions = r.data.rows || [];
        await this.service.render();
    }

    public async loadApplications() {
        const r = await wiz.call('list_applications', { program_id: this.program_id, module_id: this.module_id });
        if (r.code == 200) this.applications = r.data.rows || [];
        await this.service.render();
    }

    public async loadMentorUsers() {
        const r = await wiz.call('list_mentors', {});
        if (r.code == 200) this.mentorUsers = r.data.rows || [];
        await this.service.render();
    }

    public async setTab(t: string) {
        this.tab = t;
        if (t === 'documents') await this.loadMentorDocSubmissions();
        await this.service.render();
    }

    public goProgramApplications() {
        if (!this.program_id) return;
        this.service.href(`/admin/support/programs/${this.program_id}/applications`);
    }

    // ========== Mentors ==========
    public async addMentor() {
        if (!this.newMentor.name) {
            this.service.alert.show({ title: '입력 오류', message: '멘토명을 입력하세요.', action: '확인' });
            return;
        }
        this.config.mentors.push({
            id: 'M' + Date.now().toString(36),
            ...this.newMentor
        });
        await this.saveConfig();
        this.newMentor = { name: '', email: '', expertise: '', phone: '', org: '' };
    }

    public async removeMentor(idx: number) {
        if (!confirm('멘토를 삭제하시겠습니까?')) return;
        this.config.mentors.splice(idx, 1);
        await this.saveConfig();
    }

    private async saveConfig() {
        const r = await wiz.call('update_config', {
            module_id: this.module_id, config: JSON.stringify(this.config)
        });
        if (r.code != 200) {
            this.service.alert.show({ title: '저장 실패', message: r.data?.message || '오류', action: '확인' });
        }
        await this.service.render();
    }

    // ========== Sessions ==========
    public openSessionCreate() {
        this.editingSession = this._emptySession();
        this.editingSession.module_id = this.module_id;
        this.editingSession.program_id = this.program_id;
        this.editingSession.round_no = (this.sessions.length || 0) + 1;
        this.editingSession.title = `멘토링 ${this.editingSession.round_no}회차`;
        this.showSessionEditor = true;
        this.service.render();
    }

    public openSessionEdit(s: any) {
        this.editingSession = JSON.parse(JSON.stringify(s));
        this.showSessionEditor = true;
        this.service.render();
    }

    public closeSessionEditor() {
        this.showSessionEditor = false;
        this.editingSession = null;
        this.service.render();
    }

    public async saveSession() {
        if (!this.editingSession) return;
        this.editingSession.round_no = Number(this.editingSession.round_no) || 1;
        const isNew = !this.editingSession.id;
        const r = isNew
            ? await wiz.call('create_session', { data: JSON.stringify(this.editingSession) })
            : await wiz.call('update_session', { id: this.editingSession.id, data: JSON.stringify(this.editingSession) });
        if (r.code != 200) {
            this.service.alert.show({ title: '저장 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        this.showSessionEditor = false;
        await this.loadSessions();
    }

    public async deleteSession(s: any) {
        if (!confirm(`${s.title} 회차를 삭제하시겠습니까?`)) return;
        const r = await wiz.call('delete_session', { id: s.id });
        if (r.code != 200) {
            this.service.alert.show({ title: '삭제 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        if (this.selectedSession && this.selectedSession.id === s.id) {
            this.selectedSession = null;
            this.attendance = [];
        }
        await this.loadSessions();
    }

    // ========== Attendance ==========
    public async selectSession(s: any) {
        this.selectedSession = s;
        const r = await wiz.call('list_attendance', { session_id: s.id });
        if (r.code == 200) this.attendance = r.data.rows || [];
        await this.service.render();
    }

    public async bulkRegister() {
        if (!this.selectedSession) return;
        if (!confirm('선정된 모든 기업을 이 회차에 등록하시겠습니까?')) return;
        const r = await wiz.call('bulk_register', { session_id: this.selectedSession.id });
        if (r.code != 200) {
            this.service.alert.show({ title: '등록 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        await this.selectSession(this.selectedSession);
    }

    public async setAttendance(att: any, status: string) {
        const r = await wiz.call('mark_attendance', {
            session_id: att.session_id, application_id: att.application_id, status
        });
        if (r.code != 200) {
            this.service.alert.show({ title: '저장 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        att.status = status;
        await this.service.render();
    }

    public sessionStatusInfo(s: string) {
        return this.sessionStatusMap[s] || { label: s, cls: 'bg-zinc-100 text-zinc-600' };
    }

    public attStatusInfo(s: string) {
        return this.attStatusMap[s] || { label: s, cls: 'bg-zinc-100 text-zinc-600' };
    }

    // ========== Matching ==========
    public mentorChoices(): any[] {
        return (this.mentorUsers && this.mentorUsers.length > 0) ? this.mentorUsers : (this.config.mentors || []);
    }

    public mentorUserId(m: any): string {
        return m?.user_id || m?.id || '';
    }

    public mentorDisplayName(m: any): string {
        return m?.name || m?.email || this.mentorUserId(m);
    }

    public mentorDisplayMeta(m: any): string {
        return [m?.email, m?.affiliation || m?.org, m?.expertise].filter((v: any) => !!v).join(' · ');
    }

    public assignmentFor(mentorId: string, appId: string): any {
        return (this.assignments || []).find((a: any) => a.mentor_user_id === mentorId && a.application_id === appId && a.status !== 'cancelled') || null;
    }

    public isMatched(mentorId: string, appId: string): boolean {
        if (this.assignmentFor(mentorId, appId)) return true;
        const m = this.config.matching || {};
        const arr = m[mentorId] || [];
        return arr.indexOf(appId) >= 0;
    }

    public async toggleMatch(mentorId: string, appId: string, checked: boolean | null = null) {
        const currentlyMatched = this.isMatched(mentorId, appId);
        const nextChecked = checked === null ? !currentlyMatched : !!checked;
        const existing = this.assignmentFor(mentorId, appId);
        if (nextChecked && !existing && mentorId && mentorId.indexOf('M') !== 0) {
            const r = await wiz.call('assign_mentor', {
                program_id: this.program_id,
                module_id: this.module_id,
                mentor_user_id: mentorId,
                application_id: appId,
                role: 'mentor',
                request: JSON.stringify({}),
            });
            if (r.code != 200) {
                this.service.alert.show({ title: '매칭 실패', message: r.data?.message || '멘토 배정에 실패했습니다.', action: '확인' });
                return;
            }
            await this.loadAssignments();
            return;
        }
        if (!nextChecked && existing) {
            const r = await wiz.call('unassign_mentor', { id: existing.id });
            if (r.code != 200) {
                this.service.alert.show({ title: '해제 실패', message: r.data?.message || '멘토 배정 해제에 실패했습니다.', action: '확인' });
                return;
            }
            await this.loadAssignments();
            return;
        }
        if (!this.config.matching) this.config.matching = {};
        if (!this.config.matching[mentorId]) this.config.matching[mentorId] = [];
        const arr = this.config.matching[mentorId];
        const i = arr.indexOf(appId);
        if (nextChecked && i < 0) arr.push(appId);
        if (!nextChecked && i >= 0) arr.splice(i, 1);
        await this.saveConfig();
    }

    public assignmentSchedule(a: any): any {
        return a?.schedule || a?.extra?.schedule || {};
    }

    public scheduleSummary(a: any): string {
        const s = this.assignmentSchedule(a);
        const parts = [s.start_at || '', s.location || '', s.online_url ? '온라인' : ''].filter((v: any) => !!v);
        return parts.length > 0 ? parts.join(' · ') : '시간/장소 미정';
    }

    public async createMentorAssignment() {
        if (!this.assignmentForm.application_id || !this.assignmentForm.mentor_user_id) {
            this.service.alert.show({ title: '입력 오류', message: '기업과 멘토를 선택하세요.', action: '확인' });
            return;
        }
        const schedule = {
            start_at: this.assignmentForm.start_at || '',
            end_at: this.assignmentForm.end_at || '',
            duration_min: Number(this.assignmentForm.duration_min) || 0,
            location: this.assignmentForm.location || '',
            online_url: this.assignmentForm.online_url || '',
            note: this.assignmentForm.schedule_note || '',
        };
        const r = await wiz.call('assign_mentor', {
            program_id: this.program_id,
            module_id: this.module_id,
            mentor_user_id: this.assignmentForm.mentor_user_id,
            application_id: this.assignmentForm.application_id,
            role: this.assignmentForm.role || 'mentor',
            note: this.assignmentForm.note || '',
            request: JSON.stringify({}),
            schedule: JSON.stringify(schedule),
        });
        if (r.code != 200) {
            this.service.alert.show({ title: '배정 실패', message: r.data?.message || '멘토 배정에 실패했습니다.', action: '확인' });
            return;
        }
        this.assignmentForm = this._emptyMentorAssignmentForm();
        await this.loadAssignments();
        this.service.alert.show({ title: '배정 완료', message: '기업별 멘토링 배정을 저장했습니다.', action: '확인' });
    }

    public async removeAssignment(a: any) {
        if (!a?.id) return;
        const ok = await this.service.alert.show({
            title: '매칭 해제',
            message: `${a.application_company || this.companyNameForApp(a.application_id)} 배정을 해제하시겠습니까?`,
            action: '해제',
            actionBtn: 'warning',
            cancel: '취소',
        });
        if (!ok) return;
        const r = await wiz.call('unassign_mentor', { id: a.id });
        if (r.code != 200) {
            this.service.alert.show({ title: '해제 실패', message: r.data?.message || '멘토 배정 해제에 실패했습니다.', action: '확인' });
            return;
        }
        await this.loadAssignments();
    }

    // ========== Mentor Documents ==========
    private _defaultMentorFields(): any[] {
        return [
            { key: 'mentor_name', label: '성명', type: 'text', required: true },
            { key: 'birth_date', label: '생년월일', type: 'date', required: true },
            { key: 'phone', label: '휴대폰 번호', type: 'text', required: true },
            { key: 'email', label: '이메일', type: 'text', required: true },
            { key: 'affiliation', label: '소속 기관', type: 'text', required: true },
            { key: 'position', label: '직위', type: 'text', required: false },
            { key: 'expertise', label: '전문 분야', type: 'textarea', required: true },
            { key: 'bank_name', label: '지급 계좌 은행', type: 'text', required: false },
            { key: 'bank_account_holder', label: '예금주', type: 'text', required: false },
            { key: 'bank_account', label: '계좌번호', type: 'text', required: false },
            { key: 'privacy_consent', label: '개인정보 수집 및 이용에 동의합니다', type: 'checkbox', required: true },
            { key: 'activity_consent', label: '멘토 활동 기준 및 비밀유지 의무에 동의합니다', type: 'checkbox', required: true },
        ];
    }

    private _defaultMentorDocuments(): any {
        return {
            provide: [
                {
                    id: 'mentor_guide',
                    title: '멘토 제출서류 작성 안내',
                    description: '멘토링 진행 방식, 작성 기준, 제출 채널 안내',
                    content: '멘토는 배정된 기업의 자료를 검토하고 멘토링 결과를 활동 기록 또는 보고서로 남깁니다.\n기업 자료와 상담 내용은 지원사업 운영 목적 외로 공유하지 않습니다.',
                    attachments: [],
                    status: 'published',
                },
            ],
            request: [
                {
                    id: 'mentor_basic_consent',
                    title: '멘토 기본정보 및 활동 동의서',
                    description: '멘토 위촉과 수당 지급, 활동 관리를 위해 필요한 기본정보와 동의 항목입니다.',
                    required: true,
                    status: 'active',
                    attachments: [],
                    fields: this._defaultMentorFields(),
                },
            ],
        };
    }

    private _normalizeMentorDocuments(raw: any): any {
        const base = raw && typeof raw === 'object' ? raw : this._defaultMentorDocuments();
        if (!Array.isArray(base.provide)) base.provide = [];
        if (!Array.isArray(base.request)) base.request = [];
        for (const d of [...base.provide, ...base.request]) {
            d.attachments = this._normalizeMentorDocAttachments(d.attachments);
            if (d.fields && !Array.isArray(d.fields)) d.fields = [];
            if (Array.isArray(d.fields)) d.fields = this._normalizeMentorDocFields(d.fields, false);
        }
        return base;
    }

    private _normalizeMentorDocAttachments(attachments: any): any[] {
        if (!Array.isArray(attachments)) return [];
        return attachments.map((a: any) => ({
            name: a?.name || a?.file_name || a?.original_name || '',
            url: a?.url || a?.file_url || '',
            original_name: a?.original_name || a?.name || '',
        }));
    }

    private _normalizeMentorDocFields(fields: any, fillKey: boolean = true): any[] {
        if (!Array.isArray(fields)) return [];
        const fieldTypes = Array.isArray(this.mentorDocFieldTypes)
            ? this.mentorDocFieldTypes
            : [{ key: 'text' }, { key: 'textarea' }, { key: 'date' }, { key: 'number' }, { key: 'select' }, { key: 'checkbox' }, { key: 'file' }];
        const used: any = {};
        const out: any[] = [];
        for (let i = 0; i < fields.length; i++) {
            const f = fields[i] || {};
            const label = String(f.label || '').trim();
            let key = String(f.key || '').trim();
            if (!label && !key) continue;
            if (!key && fillKey) key = this._nextMentorDocFieldKey(out.length + 1, used);
            if (!key) key = `field_${out.length + 1}`;
            if (used[key]) key = this._nextMentorDocFieldKey(out.length + 1, used);
            used[key] = true;
            const type = fieldTypes.some((t: any) => t.key === f.type) ? f.type : 'text';
            const row: any = {
                key,
                label: label || key,
                type,
                required: !!f.required,
            };
            if (type === 'select') {
                row.options = Array.isArray(f.options)
                    ? f.options.map((v: any) => String(v || '').trim()).filter(Boolean)
                    : String(f.options || '').split(',').map((v: string) => v.trim()).filter(Boolean);
            } else if (f.options) {
                row.options = f.options;
            }
            out.push(row);
        }
        return out;
    }

    private _nextMentorDocFieldKey(index: number, used: any = {}): string {
        let key = `field_${index}`;
        let n = index;
        while (used[key]) {
            n += 1;
            key = `field_${n}`;
        }
        return key;
    }

    private _cleanMentorDocAttachmentsForSave(): any[] {
        const rows = Array.isArray(this.mentorDocForm.attachments) ? this.mentorDocForm.attachments : [];
        const out: any[] = [];
        for (const row of rows) {
            const name = String(row?.name || '').trim();
            const url = String(row?.url || '').trim();
            if (!name && !url) continue;
            if (!url) throw new Error('첨부파일 행에 파일을 선택하세요.');
            out.push({ name: name || row?.original_name || '첨부파일', url });
        }
        return out;
    }

    private _emptyMentorDoc(mode: string): any {
        if (mode === 'request') {
            return {
                id: '',
                title: '',
                description: '',
                required: true,
                status: 'active',
                attachments: [],
                fields: this._defaultMentorFields(),
            };
        }
        return {
            id: '',
            title: '',
            description: '',
            content: '',
            attachments: [],
            status: 'published',
        };
    }

    private _docListKey(mode: string): string {
        return mode === 'request' ? 'request' : 'provide';
    }

    public mentorProvidedDocs(): any[] {
        return this.config?.mentor_documents?.provide || [];
    }

    public mentorRequestedDocs(): any[] {
        return this.config?.mentor_documents?.request || [];
    }

    public async loadMentorDocSubmissions() {
        if (!this.module_id) return;
        const r = await wiz.call('list_mentor_document_submissions', {
            program_id: this.program_id,
            module_id: this.module_id,
        });
        if (r.code == 200) this.mentorDocSubmissions = r.data.rows || [];
        await this.service.render();
    }

    public async setMentorDocMode(mode: string) {
        this.mentorDocMode = mode === 'submissions' ? 'submissions' : this._docListKey(mode);
        if (this.mentorDocMode === 'submissions') await this.loadMentorDocSubmissions();
        await this.service.render();
    }

    public openMentorDocCreate(mode: string) {
        const key = this._docListKey(mode);
        this.editingMentorDoc = null;
        this.mentorDocForm = this._emptyMentorDoc(key);
        this.showMentorDocEditor = true;
        this.service.render();
    }

    public openMentorDocEdit(mode: string, doc: any) {
        const key = this._docListKey(mode);
        this.editingMentorDoc = { mode: key, id: doc.id };
        this.mentorDocForm = {
            ...this._emptyMentorDoc(key),
            ...JSON.parse(JSON.stringify(doc || {})),
        };
        this.mentorDocForm.fields = this._normalizeMentorDocFields(this.mentorDocForm.fields, false);
        this.mentorDocForm.attachments = this._normalizeMentorDocAttachments(this.mentorDocForm.attachments);
        this.showMentorDocEditor = true;
        this.service.render();
    }

    public closeMentorDocEditor() {
        this.showMentorDocEditor = false;
        this.editingMentorDoc = null;
        this.service.render();
    }

    public async uploadMentorDocAttachment() {
        if (!Array.isArray(this.mentorDocForm.attachments)) this.mentorDocForm.attachments = [];
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        await this.service.loading.show();
        try {
            for (let i = 0; i < files.length; i++) {
                const fd = new FormData();
                fd.append('upload', files[i]);
                const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
                this.mentorDocForm.attachments.push({ name: files[i].name, url });
            }
        } finally {
            await this.service.loading.hide();
            await this.service.render();
        }
    }

    public addMentorDocAttachmentRow() {
        if (!Array.isArray(this.mentorDocForm.attachments)) this.mentorDocForm.attachments = [];
        this.mentorDocForm.attachments.push({ name: '', url: '', original_name: '' });
        this.service.render();
    }

    public async uploadMentorDocAttachmentAt(index: number) {
        if (!Array.isArray(this.mentorDocForm.attachments)) this.mentorDocForm.attachments = [];
        if (!this.mentorDocForm.attachments[index]) this.addMentorDocAttachmentRow();
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        await this.service.loading.show();
        try {
            const fd = new FormData();
            fd.append('upload', files[0]);
            const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
            const row = this.mentorDocForm.attachments[index];
            row.url = url;
            row.original_name = files[0].name;
            if (!row.name) row.name = files[0].name;
        } finally {
            await this.service.loading.hide();
            await this.service.render();
        }
    }

    public removeMentorDocAttachment(index: number) {
        if (!Array.isArray(this.mentorDocForm.attachments)) return;
        this.mentorDocForm.attachments.splice(index, 1);
        this.service.render();
    }

    public addMentorDocFieldRow() {
        if (!Array.isArray(this.mentorDocForm.fields)) this.mentorDocForm.fields = [];
        const used: any = {};
        for (const f of this.mentorDocForm.fields) used[f.key] = true;
        this.mentorDocForm.fields.push({
            key: this._nextMentorDocFieldKey(this.mentorDocForm.fields.length + 1, used),
            label: '',
            type: 'text',
            required: false,
            options: '',
        });
        this.service.render();
    }

    public addMentorDocField() {
        if (!this.newMentorDocField.key || !this.newMentorDocField.label) {
            this.service.alert.show({ title: '입력 오류', message: '필드 key와 라벨을 입력하세요.', action: '확인' });
            return;
        }
        if (!Array.isArray(this.mentorDocForm.fields)) this.mentorDocForm.fields = [];
        const f: any = {
            key: this.newMentorDocField.key,
            label: this.newMentorDocField.label,
            type: this.newMentorDocField.type || 'text',
            required: !!this.newMentorDocField.required,
        };
        if (f.type === 'select' && this.newMentorDocField.options) {
            f.options = this.newMentorDocField.options.split(',').map((s: string) => s.trim()).filter(Boolean);
        }
        this.mentorDocForm.fields.push(f);
        this.newMentorDocField = { key: '', label: '', type: 'text', required: false, options: '' };
    }

    public removeMentorDocField(i: number) {
        this.mentorDocForm.fields.splice(i, 1);
        this.service.render();
    }

    public moveMentorDocField(i: number, dir: number) {
        const j = i + dir;
        if (j < 0 || j >= this.mentorDocForm.fields.length) return;
        const tmp = this.mentorDocForm.fields[i];
        this.mentorDocForm.fields[i] = this.mentorDocForm.fields[j];
        this.mentorDocForm.fields[j] = tmp;
        this.service.render();
    }

    public mentorDocFieldOptionsText(f: any): string {
        if (!f) return '';
        return Array.isArray(f.options) ? f.options.join(', ') : String(f.options || '');
    }

    public setMentorDocFieldOptionsText(f: any, value: string) {
        if (!f) return;
        f.options = value;
    }

    public async submitMentorDoc() {
        const mode = this._docListKey(this.editingMentorDoc?.mode || this.mentorDocMode);
        if (!this.mentorDocForm.title) {
            this.service.alert.show({ title: '입력 오류', message: '서류명을 입력하세요.', action: '확인' });
            return;
        }
        if (!this.config.mentor_documents) this.config.mentor_documents = this._normalizeMentorDocuments({});
        const list = this.config.mentor_documents[mode] || [];
        const payload = {
            ...this.mentorDocForm,
            id: this.mentorDocForm.id || ('MD' + Date.now().toString(36)),
        };
        try {
            payload.attachments = this._cleanMentorDocAttachmentsForSave();
        } catch (e: any) {
            this.service.alert.show({ title: '입력 오류', message: e?.message || '첨부파일을 확인하세요.', action: '확인' });
            return;
        }
        payload.fields = mode === 'request' ? this._normalizeMentorDocFields(payload.fields, true) : [];
        const idx = list.findIndex((d: any) => d.id === payload.id);
        if (idx >= 0) list[idx] = payload;
        else list.push(payload);
        this.config.mentor_documents[mode] = list;
        this.showMentorDocEditor = false;
        await this.saveConfig();
    }

    public async removeMentorDoc(mode: string, doc: any) {
        const ok = await this.service.alert.show({
            title: '서류 삭제',
            message: `"${doc.title}" 항목을 삭제하시겠습니까?`,
            action: '삭제',
            actionBtn: 'error',
            cancel: '취소',
        });
        if (!ok) return;
        const key = this._docListKey(mode);
        this.config.mentor_documents[key] = (this.config.mentor_documents[key] || []).filter((d: any) => d.id !== doc.id);
        await this.saveConfig();
    }

    public mentorDocFieldTypeLabel(type: string): string {
        const found = this.mentorDocFieldTypes.find((t: any) => t.key === type);
        return found ? found.label : type;
    }

    public openMentorDocSubmission(s: any) {
        this.selectedMentorDocSubmission = s;
        this.service.render();
    }

    public closeMentorDocSubmission() {
        this.selectedMentorDocSubmission = null;
        this.service.render();
    }

    public mentorDocRequestForSubmission(s: any): any {
        const rid = s?.request_id || s?.extra?.request_id || '';
        if (!rid) return null;
        return this.mentorRequestedDocs().find((d: any) => d.id === rid) || null;
    }

    public mentorDocSubmissionValues(s: any): any[] {
        const data = (s?.form_data && typeof s.form_data === 'object') ? s.form_data : {};
        const req = this.mentorDocRequestForSubmission(s);
        const fields = Array.isArray(req?.fields) ? req.fields : [];
        const rows: any[] = [];
        const used: any = {};
        for (const f of fields) {
            const key = f?.key || '';
            if (!key) continue;
            used[key] = true;
            rows.push({ key, label: f.label || key, type: f.type || 'text', value: data[key] });
        }
        for (const key of Object.keys(data)) {
            if (used[key]) continue;
            rows.push({ key, label: key, type: 'text', value: data[key] });
        }
        return rows;
    }

    public mentorDocValueText(row: any): string {
        const value = row?.value;
        if (row?.type === 'checkbox') return value === true ? '동의' : '미동의';
        if (value === undefined || value === null || value === '') return '-';
        if (Array.isArray(value)) return value.join(', ');
        if (typeof value === 'object') return value.name || value.file_name || value.url || JSON.stringify(value);
        return String(value);
    }

    public mentorDocValueUrl(row: any): string {
        const value = row?.value;
        if (!value) return '';
        if (typeof value === 'object') return value.url || value.file_url || '';
        const text = String(value);
        if (text.indexOf('/file/download/') === 0 || text.indexOf('http://') === 0 || text.indexOf('https://') === 0) return text;
        return '';
    }

    public mentorDocStatusLabel(doc: any): string {
        if (!doc) return '-';
        if (doc.status === 'published') return '공개';
        if (doc.status === 'active') return '요청중';
        if (doc.status === 'draft') return '작성중';
        return doc.status || '-';
    }
}

export default PortalLpsysadminSupportModuleMentoringComponent;